import { IOccupancy } from "src/data/occupancy/types/occupancyTypes"
import OccupancyOffActive from "src/ui/icons/occupancy-detection-off-active.svg"
import OccupancyOffOutlined from "src/ui/icons/occupancy-detection-off-outlined.svg"
import OccupancyOnActive from "src/ui/icons/occupancy-detection-on-active.svg"
import OccupancyOnOutlined from "src/ui/icons/occupancy-detection-outlined.svg"
import { SVGProps } from "src/utils/tsUtil"

/**
 * PresenceAndOccupancyToggleIcon
 * Toggle icon specifically for popover buttons that control both presence and occupancy detection.
 * Shows appropriate on/off icons based on toggle state and current feature states.
 * @example <PresenceAndOccupancyToggleIcon toggleState="on" occupancyActive={true} motionAutomationState="enabled" />
 */
export function PresenceAndOccupancyToggleIcon({
  toggleState,
  occupancyActive,
  motionAutomationState,
  iconProps,
}: {
  toggleState: "on" | "off"
  occupancyActive?: IOccupancy["active"]
  motionAutomationState?: "enabled" | "disabled"
  iconProps?: SVGProps
}) {
  // Determine if either feature is currently enabled
  const isOccupancyEnabled = occupancyActive === true
  const isMotionAutomationEnabled = motionAutomationState === "enabled"
  const isAnyFeatureEnabled = isOccupancyEnabled || isMotionAutomationEnabled

  if (toggleState === "on") {
    // Show active icon if any feature is already enabled, outlined if not
    if (isAnyFeatureEnabled) {
      return <OccupancyOnActive height="56" {...iconProps} />
    }
    return <OccupancyOnOutlined height="56" {...iconProps} />
  }

  // toggleState === "off"
  // Show active icon if no features are enabled (can turn off), outlined if features are enabled
  if (!isAnyFeatureEnabled) {
    return <OccupancyOffActive height="56" {...iconProps} />
  }
  return <OccupancyOffOutlined height="56" {...iconProps} />
}
